import { getUniqueName } from '@/shared/lib/format/getUniqueName';

import { DASHBOARD_DEFAULT_BASE_NAME } from '../constants/names';

/**
 * Generates a unique dashboard name based on existing dashboards.
 * Returns "My Dashboard" if available, otherwise "My Dashboard (2)", "My Dashboard (3)", etc.
 */
export const getUniqueDashboardName = (existingNames: string[]): string => {
  return getUniqueName(existingNames, DASHBOARD_DEFAULT_BASE_NAME);
};
